import { Property } from './property';

// istanbul ignore file
export enum QuoteStatus {
    Pending = 'PENDING',
    AwaitingApproval = 'AWAITING_APPROVAL',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED',
    Cancelled = 'CANCELLED',
    Completed = 'COMPLETED',
    Expired = 'EXPIRED',
    ReactivationRequestExternal = 'REACTIVATION_REQUEST_EXTERNAL',
    ReactivationRequestInternal = 'REACTIVATION_REQUEST_INTERNAL',
    ReadyToSend = 'READY_TO_SEND'
}

export enum QuoteSeverity {
    DisconnectedOrSafetyIssue = 'DISCONNECTED_SAFETY_ISSUE',
    NonCompliantOrFaulty = 'NON_COMPLIANT_FAULTY',
    Recommended = 'RECOMMENDED',
    Urgent = 'URGENT'
}

export type GetQuotesOptions = {
    propertyId?: number;
    propertyManagerId?: number;
    status?: QuoteStatus;
    urgent?: boolean | number;
    expiresBefore?: string;
    expiresAfter?: string;
    pageSize?: number;
};

export type EstimatedQuotePrices = {
    total: number;
    compulsory: number;
    optional: number;
    minimum?: number;
};

export type Quote = {
    complianceQuoteId: number;
    quoteNumber: string;
    issuedAt: string;
    expiresAt: string;
    quoteSeverity: QuoteSeverity | null;
    status: QuoteStatus;
    respondedBy: string | null;
    acceptedBy: string | null;
    acceptedAt: string | null;
    acceptedTotalIncGst: number | null;
    awaitingApprovalBy: string;
    numberOfItems: number;
    pdfUrl: string;
    approvalUrl: string | null;
    property: Property;
    service: {
        name: string;
        shortName: string;
    };
};
